import './src/vaadin-accordion.js';
export * from './src/vaadin-accordion.js';
